const fullyLoaded = () => document.readyState === 'complete';

export default (additionalDelay = 3000): Promise<void> =>
  new Promise((resolve) => {
    const init = () => {
      if (fullyLoaded()) {
        document.removeEventListener('readystatechange', init);
        window.setTimeout(() => {
          resolve();
        }, additionalDelay);
      }
    };

    if (fullyLoaded()) {
      return init();
    }
    document.addEventListener('readystatechange', init);
  });
